import { createDecorator } from "vue-class-component";

export const SearchinStore = createDecorator((options, key) => {
    //args[0] - source
    //args[1] - name
    //args[2] - useStudio
    //args[3] - name дополнительное поле
    //args[4] - filter

    if (options.methods) {
        const originalMethod = options.methods[key];

        options.methods[key] = function wrapperMethod(...args) {
            try {
                let filter = {};
                let fieldName = "name";
                if (args[3]) {
                    fieldName = args[3];
                }
                if (args[2] && args[2] === true) {
                    const studioId = this.$router.currentRoute.params["Studio"]
                        ? this.$router.currentRoute.params["Studio"]
                        : this.$store.state["salon_id"];
                    filter = {
                        [fieldName]: args[1],
                        salon_id: studioId,
                        exist_studios: args[2],
                    };
                } else {
                    if (!args[4]) {
                        filter = {
                            [fieldName]: args[1],
                        };
                    } else {
                        Object.assign(filter, args[4]);
                    }
                }
                this.$store
                    .dispatch(args[0] + "/fetchAll", {
                        limit: 10,
                        filter: filter,
                    })
                    .then(() => {
                        originalMethod.apply(this, args);
                    });
            } catch (e) {
                console.log("Error parsing Data :" + e);
            }
        };
    }
});
export const HandleScrollStore = createDecorator((options, key) => {
    if (options.methods) {
        const originalMethod = options.methods[key];
        options.methods[key] = function wrapperMethod(...args) {
            console.log('wrapperMethod', options, key)
            const target = args[0].target,
                source = args[1];

            let items = args[1];
            if (args[2] !== undefined) {
                items = args[2]
            }
            console.log('items', items)
            console.log('target', target)
            console.log('source', source)
            console.log('store', this.$store.state[source])

            if (Number(target.scrollTop) + Number(target.offsetHeight) >= target.scrollHeight) {
                if (this.$store.state[source][items]["data"].length < this.$store.state[source][items]["total"]) {

                    try {
                        this.$store
                            .dispatch(source + "/fetchAll", {
                                limit: 10 + this.$store.state[source][items]["data"].length,
                            })
                            .then(() => [originalMethod.apply(this, args)]);
                    } catch (e) {
                        console.log();
                    }
                }
            }
        };
    }
});
//Обязательно учитывает Studio Id
export const HandleScrollStorewithParam = createDecorator((options, key) => {
    if (options.methods) {
        const originalMethod = options.methods[key];
        options.methods[key] = function wrapperMethod(...args) {
            const target = args[0].target;
            if (Number(target.scrollTop) + Number(target.offsetHeight) >= target.scrollHeight) {
                //console.log('HandleScrollStorewithParam')
                const studioId = this.$router.currentRoute.params["Studio"]
                    ? this.$router.currentRoute.params["Studio"]
                    : this.$store.state["salon_id"];

                // Check if args[4] is provided, and if not, initialize it as an empty object
                const customParams = args[4] || {};
                if (studioId) {
                    if (
                        this.$store.state[args[1]][args[2]]["data"].length <
                        this.$store.state[args[1]][args[2]]["total"]
                    ) {
                        try {
                            this.$store
                                .dispatch(args[1] + "/fetchAll", {
                                    limit: 10 + this.$store.state[args[1]][args[2]]["data"].length,
                                    filter: { salon_id: studioId, exist_studios: args[3], ...customParams },
                                })
                                .then(() => [originalMethod.apply(this, args)]);
                        } catch (e) {
                            console.log();
                        }
                    }
                } else if (
                    this.$store.state[args[1]][args[2]]["data"].length < this.$store.state[args[1]][args[2]]["total"]
                ) {
                    try {
                        this.$store
                            .dispatch(args[1] + "/fetchAll", {
                                limit: 10 + this.$store.state[args[1]][args[2]]["data"].length,
                            })
                            .then(() => [originalMethod.apply(this, args)]);
                    } catch (e) {
                        console.log();
                    }
                }
            }
        };
    }
});


export const SearchData = createDecorator((option, key) => {
    // args1 - source
    // args2 - value
    if (option.methods) {
        const originalMethod = option.methods[key];
        option.methods[key] = function wrapperMethod(...args) {
            this.$store.dispatch(args[0] + "/fetchAll", {
                limit: 10,
                filter: args[1],
            }).then(() => [originalMethod.apply(this, args)]);
        }
    }
})
export const ScrollData = createDecorator((option, key) => {
    if (option.methods) {
        const originalMethod = option.methods[key];
        let count = 10;
        let timeoutId: number | null | undefined = null;
        const debounceDelay = 300;

        option.methods[key] = function wrapperMethod(...args) {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }

            timeoutId = setTimeout(() => {
                this.$store.dispatch(args[0] + "/fetchAll", {
                    limit: count += 5,
                    filter: args[1]
                }).then(() => [originalMethod.apply(this, args)]);
            }, debounceDelay);
        }
    }
})